'use client';

import React from 'react';

import classes from './confirm.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { setConfirmClickState } from '@/slice/confirm';

function Confirm({ dict }: { dict: { confirm: string; cancel: string } }) {
  const dispatch = useDispatch();
  const confirmMessage = useSelector(
    (state: RootState) => state.confirm.message,
  );

  const handleConfirmClick = (clickState: string) => {
    dispatch(setConfirmClickState(clickState));
  };

  return (
    <article
      className={classes.msgLayer}
      style={confirmMessage !== '' ? { display: 'block' } : { display: 'none' }}
    >
      <div className={classes.msgLayerWrapper}>
        <div className={classes.msgContents}>
          <div className={classes.msgGroupBox}>
            <div className={classes.msgViewBox}>
              <div className={classes.icBox}>
                <i className={`${classes.ic} ${classes.icInfo}`}></i>
              </div>
              <div className={classes.msgBox}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: confirmMessage.replace(/\n/g, '<br />'),
                  }}
                />
              </div>
            </div>
            <div className={classes.msgBtnBox}>
              <div className={classes.btnList}>
                <div className={classes.btnBox}>
                  <button
                    className={`${classes.btn} ${classes.themeSuccess}`}
                    onClick={() => handleConfirmClick('confirm')}
                  >
                    <span>{dict.confirm}</span>
                  </button>
                </div>
                <div className={classes.btnBox}>
                  <button
                    className={`${classes.btn} ${classes.themeCancel}`}
                    onClick={() => handleConfirmClick('cancel')}
                  >
                    <span>{dict.cancel}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Confirm;
